/* eslint-disable no-underscore-dangle */
import { GetRegion } from 'constants.js';
import _ from 'lodash';
import { pushSession } from 'containers/User/service';

export const isStickySessionEnabled = () => {
  const stickySession = JSON.parse(
    _.get(window, ['metadata', 'sticky_session'], '{}'),
  );
  const keySticky = stickySession[GetRegion()] || stickySession.default;
  return _.get(keySticky, ['user_id'], false);
};

export const isStickyPushEnabled = () => {
  const stickySession = JSON.parse(
    _.get(window, ['metadata', 'sticky_session'], '{}'),
  );
  const keySticky = stickySession[GetRegion()] || stickySession.default;
  return _.get(keySticky, ['push_session'], false);
};

const getStickySession = () => {
  const user = window.utils.userType.checkUserData();
  const isEnabled = isStickySessionEnabled();
  if (isEnabled && !_.isEmpty(user)) {
    return { user_id: user.user_id || '' };
  }
  return {};
};

export const execSafePushSession = (user = {}) => {
  let _user = user;
  if (_.isEmpty(_user)) _user = window.utils.userType.checkUserData();

  if (isStickyPushEnabled() && !_.isEmpty(_user)) {
    const body = {
      user_session: user.user_session,
    };
    const params = {
      user_id: user.user_id,
    };
    return pushSession(params, body);
  }
  return Promise.resolve({ status: 200 });
};

export default getStickySession;
